// extracted by mini-css-extract-plugin
module.exports = {"amber":"metadata_amber__1RFKy","green":"metadata_green__1Hyg9"};